import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicLayout from "@/layouts/BasicLayout"
import SecurityLayout from "@/layouts/SecurityLayout"
import FullSecurityLayout from "@/layouts/FullSecurityLayout"

Vue.use(VueRouter)

import view_routes from '@/views/routes'

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/index',
    component: BasicLayout,
    meta: {title: '首页'},
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {title: '登录'},
      }
    ]
  },
  {
    path: '/',
    component: SecurityLayout,
    meta: {title: '首页'},
    children: [
      ...view_routes,
    ]
  },
  {
    path: '/',
    component: FullSecurityLayout,
    meta: {title: '大屏'},
    children: [
      {
        path: '/car',
        name: 'Car',
        component: () => import('@/views/Car.vue'),
        meta: {title: '轿车大屏'},
      },
      {
        path: '/bus',
        name: 'Bus',
        component: () => import('@/views/Bus.vue'),
        meta: {title: '客车大屏'},
      },
      {
        path: '/c8m',
        name: 'C8M',
        component: () => import('@/views/C8M.vue'),
        meta: {title: '远程C8M醇氢电动商用客车数字孪生系统'},
      },
    ]
  },
  {
    path: '*',
    redirect: '/exception/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
